import { useMutation, useQueryClient } from 'react-query';
import { deleteRecognitionAsync } from 'services/Recognition';
import { RECOGNITION_KEYS } from 'services/Recognition/hooks/useQuery';
import { IRecognitionTypes } from '../../../types';
import {
  createStudentRecognitionAsync,
  getAllStudentsByLicenseAsync,
  getAllStudentsForSelectionAsync,
  getStudentRecognitionByIdAsync,
  updateStudentRecognitionAsync,
} from '../../index';
import { STUDENT_KEYS } from '../useQuery/index';

export const useCreateStudentRecognitionAsync = () => {
  const queryClient = useQueryClient();
  
  return useMutation(createStudentRecognitionAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([STUDENT_KEYS.ALL]); 
    },
  });
};

export const useUpdateStudentRecognitionAsync = () => {
  const queryClient = useQueryClient();
  
  return useMutation(updateStudentRecognitionAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([STUDENT_KEYS.ALL]);
    },
  });
};

export const useDeleteStudentAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (id: number) => deleteRecognitionAsync({ id, type: IRecognitionTypes.STUDENT }), 
    {
      onSuccess: () => {
        queryClient.invalidateQueries([STUDENT_KEYS.ALL]);
        queryClient.invalidateQueries([RECOGNITION_KEYS.ALL]); 
      }
    }
  );
};

export const useGetStudentRecognitionByIdAsync = () =>
  useMutation(getStudentRecognitionByIdAsync);

export const useGetAllStudentsByLicenseMutateAsync = () =>
  useMutation(getAllStudentsByLicenseAsync);

export const useGetAllStudentsForSelectionMutateAsync = () => {
  return useMutation(getAllStudentsForSelectionAsync);
};